import { Link } from "react-router-dom";
import SkeletonLoading from "../../../../Components/Skeleton/SkeletonLoading";
// import { useAppSelector } from "../../../../Store/Hooks";
// import {dashboardFilters} from "../../../../Store/Alerts/selectors"
// import { useRef } from "react";
// import { alertActions } from "../../../../Store/Alerts/reducer";
// import { SelectOptionObjectType } from "../../../../Services/Models/Misc/HelperModels";
// import DashboardSearch from "./DashboardFilters/DashboardSearch";
// import DashboardTimeFilter from "./DashboardFilters/DashboardTimeFilter";
// import DashboardDiseaseFilter from "./DashboardFilters/DashboardDiseaseFilter";

type Props = {
  isBackButton: boolean;
  searchApply:any;
  tableData: any;
  isLoading: boolean;
};

const DashboardHeader: React.FC<Props> = (Props) => {
  // const filters = useAppSelector(dashboardFilters);
  // const dispatch = useAppDispatch();
  // const diseaseSelectRef = useRef<any>();
  // const searchRef = useRef<any>();
  // const grupselect=useRef<any>();
  // const showSelectRef=useRef<any>();
  // const notificationRef = useRef<any>();
  // const [isActive, setIsActive] = useState(false);

  // const handleClick = () => {
  //   if(!isActive){
  //     document.body.classList.add('backdroper');
  //     document.addEventListener('click',handleOutsideClick.bind(this),false);
  //   }
  //   else{
  //     document.body.classList.remove('backdroper');
  //     document.removeEventListener('click',handleOutsideClick.bind(this),false);
  //   }
  //   setIsActive((current) => !current);
  // };

  // const handleOutsideClick = (e:any)=>{
  //   if(!notificationRef.current.contains(e.target)){
  //     document.body.classList.remove('backdroper')
  //     setIsActive(false);
  //   }
  // }

  // const onSearch = (text: string) => {
  //   const filtered: any = Props.tableData.filter((entry:any) =>
  //     (typeof entry.name === "string" && entry.name.toLowerCase().includes(text.toLowerCase())) ||
  //     (typeof entry.deviceID === "string" && entry.deviceID.toLowerCase().includes(text.toLowerCase())));
  //   Props.searchApply(filtered);
  // };

  // const onFilterChange = (e: SelectOptionObjectType, key: string) => {
  //   const text:any = e?.value;
  //   if(key === "disease" && text !== undefined){
  //   const filtered: any = Props.tableData.filter((entry:any) =>
  //     (entry.medicalCondition.includes(text)));
  //   Props.searchApply(filtered);
  // }else{
  //   Props.searchApply(Props.tableData);
  // }
  //   dispatch(alertActions.getFilteredAlertsRequest({...filters, [key]: {...e}}))
  // }
  
  return (
    <>
      {Props.isBackButton && (
        <div className="back-button">
          <button type="button">Back</button>
        </div>
      )}
      <div className="header-top header-bg header-spacing">
        <div className="cols d-flex">
          {/* <DashboardDiseaseFilter diseaseSelectRef={diseaseSelectRef} filters={filters} onFilterChange={onFilterChange} /> */}
          {/* <DashboardTimeFilter filters={filters} onFilterChange={onFilterChange} showSelectRef={showSelectRef} /> */}
        </div>
        <div className="search-group d-flex flex-column align-items-end position-relative">
          {/* <label htmlFor="" className="label"></label> */}
          <div className="d-flex align-items-center">
            {/* <DashboardSearch searchRef={searchRef} onSearch={onSearch} /> */}
            {/* <div className="notification-block" ref={notificationRef}>
              <button className="btn notification-well" onClick={handleClick}>
                <img
                  src="Assets/Images/Icons/notification-well.svg"
                  alt="Caution"
                  width="19"
                  height="28"
                  className="well-icon"
                />
              </button>
              <div
                className={
                  isActive ? "open notification-card" : "notification-card"
                }
              >
                <div className="noti-header position-relative">
                  <button
                    className="btn back-angle"
                    onClick={() => handleClick()}
                    type="button"
                  >
                    <span className="fa-solid fa-angle-left"></span>
                  </button>
                  <h2 className="title theme-color text-center">
                    Notifications
                  </h2>
                </div>

                <ul className="notification-dropdown">
                  <li className="item d-flex  justify-content-between unread">
                    <span className="kd-title d-flex flex-column">
                      <span className="group">
                        <span className="noti-name"> Dennis Malcom</span>
                        <span className="noti-code">#KD01RBA0013</span>
                      </span>
                      <span className="desc">
                        Sleep duration lower than normal
                      </span>
                    </span>
                    <span className="noti-time">Now</span>
                  </li>
                  <li className="item d-flex  justify-content-between">
                    <span className="kd-title d-flex flex-column">
                      <span className="group">
                        <span className="noti-name">
                          Michael B. Worthington
                        </span>
                        <span className="noti-code">#KD01RBA0014</span>
                      </span>
                      <span className="desc">
                        Sleep duration lower than normal
                      </span>
                    </span>
                    <span className="noti-time">Today, 04:46pm</span>
                  </li>
                  <li className="item d-flex  justify-content-between">
                    <span className="kd-title d-flex flex-column">
                      <span className="group">
                        <span className="noti-name-name">
                          Frank C. Childress
                        </span>
                        <span className="noti-code">#KD01RBA0015</span>
                      </span>
                      <span className="desc">
                        Sleep duration lower than normal
                      </span>
                    </span>
                    <span className="noti-time">10 Feb 2023, 3:35pm</span>
                  </li>
                </ul>
              </div>
            </div> */}
            {Props.isLoading ? (
              <>
                <SkeletonLoading width={200} height={48} style={{ boxShadow: "0px 1px 10px 1px rgba(102, 207, 200, 0.35)" }} />
                <SkeletonLoading width={125} height={48} style={{ marginLeft: "30px", boxShadow:"0px 1px 10px 1px rgba(102, 207, 200, 0.35)"}} />
              </>
            ) : (
              <>
                <Link to={"mailto:providersupport@kiddo.health"} className="btn btn-success success-reverse justify-content-end fs-16 w-auto text-nowrap">
                  Contact Kiddo support
                </Link>
                <Link to={"/addpatientleads"} className="btn btn-success justify-content-end fs-16 w-auto text-nowrap btn-dashboard-add-patient">
                  Add Patients
                </Link>
              </>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardHeader;
